import { PanelState, UIPanel } from "@/types/ui";
import defensiveCopy from "@/util/defensive-copy";

const PANELS_BANNED_IN_OXYGEN: UIPanel[] = ["presets"];
const PANELS_BANNED_IN_BREAKDANCE: UIPanel[] = [];

export function removeBannedPanelsFromPanelState(
  panelState: PanelState,
  builderMode: "breakdance" | "oxygen" | null
) {
  if (!builderMode) return panelState;

  const cleanedPanelState = defensiveCopy(panelState);

  if (builderMode === "oxygen") {
    if (
      (PANELS_BANNED_IN_OXYGEN as string[]).includes(
        panelState.leftSidebarPanel
      )
    ) {
      cleanedPanelState.leftSidebarPanel = "closed";
    }

    if (
      (PANELS_BANNED_IN_OXYGEN as string[]).includes(
        panelState.rightSidebarPanel
      )
    ) {
      cleanedPanelState.rightSidebarPanel = "closed";
    }
  }

  if (builderMode === "breakdance") {
    if (
      (PANELS_BANNED_IN_BREAKDANCE as string[]).includes(
        panelState.leftSidebarPanel
      )
    ) {
      cleanedPanelState.leftSidebarPanel = "closed";
    }

    if (
      (PANELS_BANNED_IN_BREAKDANCE as string[]).includes(
        panelState.rightSidebarPanel
      )
    ) {
      cleanedPanelState.rightSidebarPanel = "closed";
    }
  }

  return cleanedPanelState;
}
